import {createRoot} from 'react-dom/client';
import {StrictMode} from 'react';


import {App,ErrorBoundary} from './App.js';
import {StoreProvider} from './store.js';
const root=document.getElementById('root');
if(!root)throw new Error('Le conteneur de l’application est manquant.');
createRoot(root).render(<StrictMode><ErrorBoundary><StoreProvider><App/></StoreProvider></ErrorBoundary></StrictMode>);
